import { render, staticRenderFns } from "./mobile-menu.vue?vue&type=template&id=47f71693"
import script from "./mobile-menu.vue?vue&type=script&lang=js"
export * from "./mobile-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/mobile-menu/mobile-menu.vue
// module id = ah8p
// module chunks = 0